import posthog from "posthog-js"

export function captureEvent(
  eventName: string,
  properties?: Record<string, any>,
) {
  posthog.capture(eventName, properties)
}

export function identifyUser(userId: string, userInfo?: Record<string, any>) {
  posthog.identify(userId, userInfo)
}
